import React, { Component } from "react";
import { FaCircleExclamation } from "react-icons/fa6";
import ReactTooltip from "react-tooltip";


export default class ArchiveSearchBox extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <section className="filter">
                <h3 className="filter__title">Zoek op trefwoord <FaCircleExclamation data-tip={this.props.tooltipText} />
                <ReactTooltip place="top" effect="solid" /> </h3>
            
                <fieldset
                    className="filter__container filter__container--input"
                    method="get"
                >
                    <label htmlFor="trefwoord" className="filter__label">
                        Zoek op trefwoord
                    </label>
                    <input
                        type="text"
                        className="filter__field"
                        id="trefwoord"
                        name="search"
                        value={this.props.searchQuery}
                        placeholder="Zoek op trefwoord"
                        onChange={e => this.props.onChanged(e)}
                        onKeyPress={e => {
                            if (e.key === "Enter") this.props.onEnter(e);
                        }}
                    />
                </fieldset>
            </section>
        );
    }
}
